import { useParams } from 'react-router-dom';

import { AppUserBadgesPage } from '~/components/pages/AppUserBadgesPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppUserBadgesRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUserBadgesPage appId={appId} />
    </DashboardTemplate>
  );
};
